import { combineReducers } from 'redux';
import appState from './states/app';
import comparisonDocumentsState from './states/comparison_documents';
import documentState from './states/document';
import orgMetadataState from './states/org_metadata';
export const rootReducer = combineReducers({
    appState,
    comparisonDocumentsState,
    orgMetadataState,
    documentState,
});
export const createRootReducer = () => combineReducers({
    appState,
    comparisonDocumentsState,
    orgMetadataState,
    documentState,
});
